import React from "react";
import PillIndicator from "@common/PillIndicator/PillIndicator";

interface ProPillIndicatorProps {
    readonly className?: string;
}
export default function ProPillIndicator(props: ProPillIndicatorProps) {
    return <PillIndicator className={props.className} label={"Pro"} color={"purple"} />;
}
